import { defineStore } from 'pinia';
import { ref } from 'vue';
import salesAPI from '@/api/sales';
import type { Sale } from '@/types/Sale';

export const useSalesStore = defineStore('sales', () => {
  const sales = ref<Sale[]>([]);
  /*const sold_by_user = ref<any>([]);
  const sold_by_medium = ref<any>([]);
  const sold_by_poster = ref<any>([]);
  const sold_by_product = ref<any>([]);
  const sales_otals = ref<any>([]);*/
  
  const fetchSales = async (params: any): Promise<{ data: Sale[]; total: number }> => {
    try {
      const response = await salesAPI.getSales(params);
      const data: Sale[] = response.data.data;
      const total = response.data.meta.total;
      sales.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching sale s:', error);
      throw error;
    }
  };

  const fetchSaleById = async (id: number) => {
    try {
      const response = await salesAPI.getSaleById(id);
      return response.data.data as Sale;
    } catch (error) {
      console.error(`Error fetching sale  with ID ${id}:`, error);
    }
  };

  const createSale = async (saleData: Partial<Sale>) => {
    try {
      const response = await salesAPI.createSale(saleData);
      sales.value.push(response.data.data as Sale);
      return response.data;
    } catch (error) {
      console.error('Error creating sale :', error);
    }
  };

  const updateSale = async (id: number, saleData: Partial<Sale>) => {
    try {
      const response = await salesAPI.updateSale(id, saleData);
      const updated = response.data.data as Sale;
      const index = sales.value.findIndex((c:any) => c.id === id);
      if (index !== -1) {
        sales.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating sale  with ID ${id}:`, error);
    }
  };

  const deleteSale = async (id: number) => {
    try {
      await salesAPI.deleteSale(id);
      sales.value = sales.value.filter((c) => c.id !== id);
    } catch (error) {
      console.error(`Error deleting sale  with ID ${id}:`, error);
    }
  };

  /*
  const soldByUser = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await salesAPI.getSoldByUser(params);
      const data = response.data;
      sold_by_user.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  const soldByMedium = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await salesAPI.getSoldByMedium(params);
      const data = response.data;
      sold_by_medium.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  const soldByPoster = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await salesAPI.getSoldByPoster(params);
      const data = response.data;
      sold_by_poster.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  const soldByProduct = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await salesAPI.getSoldByProduct(params);
      const data = response.data;
      sold_by_product.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  const salesTotals = async (params: any): Promise<{ data: any; }> => {
    try{
      const response = await salesAPI.getSalesTotals(params);
      const data = response.data;
      sales_otals.value = data
      return data;
    } catch (error){
      throw error;
    }
  };
  */

  return {
    sales,
    fetchSales,
    fetchSaleById,
    createSale,
    updateSale,
    deleteSale,
    /*soldByUser,
    soldByMedium,
    soldByPoster,
    soldByProduct,
    salesTotals*/
  };
});
